import { StrictMode } from 'react'
import { render } from 'react-dom'
import Root from './containers'

render(<Root />, document.getElementById('root'))
